import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UploadFileTask } from '../../../classes';
import { ITransactionSummaryView } from '../../../interfaces';
import { Step, StepStatus, STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';

@Component({
  selector: 'app-upload-form-summary',
  templateUrl: './upload-form-summary.component.html',
  styleUrls: ['./upload-form-summary.component.css']
})
export class UploadFormSummaryComponent implements ITransactionSummaryView, OnInit {

  StepStatus = StepStatus;

  files: { name: string, size: number }[] = [];
  counter: number = 0;

  constructor(
    @Inject(STEP_FORM_GROUP) public formGroup: FormGroup,
    @Inject('step') public step: Step
  ) { }

  ngOnInit(): void {
    this.validate();
  }

  validate(){
    let task = this.uploadTask;
    task.data.forEach((x: File) => {
      this.counter++;
      this.files.push({ name: x.name, size: x.size });
    });
  }

  get uploadTask(): UploadFileTask {
    return this.formGroup.controls['upload'].value as UploadFileTask;
  }

}
